import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsService } from '@core/services/app-settings/app-settings.service';
import { BaseDataService } from '@core/services/base-data/base-data.service';
import { ControllerRoute } from '@shared/models/enums/controller-route.enum';
import { GraphApiContact } from '@training/models/graph-api-contact.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GraphApiContactDataService extends BaseDataService {
  constructor(appSettingsService: AppSettingsService, httpClient: HttpClient) {
    super(appSettingsService, httpClient);
    this.appendResource(ControllerRoute.Contact);
  }

  public getGraphApiContactInfo(email: string): Observable<GraphApiContact> {
    const url = `${this.apiResourceUrl}/${email}`;

    return this.httpClient.get<GraphApiContact>(url, this.httpOptions);
  }
}
